import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./NewCreditCardForm";
import GraphQLErrors from "../../shared/GraphQLErrors";
import {cancelAddCreditCard} from "../../actions/AccountActions";
import {Map} from "immutable";
import { StripeProvider, Elements } from 'react-stripe-elements';
import { getStripePublishableKey } from "../../config";
import LoadingLine from "../../shared/components/forms/LoadingLine";
import { withTranslation } from "react-i18next";

function validateForm(values) {
  let errors = Map();
  return errors.toJS();
}

class AddCreditCardFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      errors: [],
      submitting: false
    }
  }

  handleSubmit(paymentMethodId) {
    let values = {accountId: this.props.accountId, paymentMethodId: paymentMethodId};
    this.setState({submitting: true});
    this.props.customerAddPaymentMethod(values)
      .then((response) => {
        if (response.data.customerAddPaymentMethod.errors.length <= 0) {
          this.setState({submitting: false});
          this.props.cancelAddCreditCard();
        } else {
          let better_errors = {_error: this.props.t("credit_card.add_failure")}
          this.setState({errors: better_errors, submitting: false});
        }
      })
      .catch((err) => {
        let better_errors = {_error: this.props.t("credit_card.add_failure")}
        this.setState({errors: better_errors, submitting: false});
      });
  }

  handleCancel() {
    this.props.cancelAddCreditCard();
  }

  render() {
    // Need to load the jurisdiction for this account.
    let {data} = this.props;
    if (data.loading) return <LoadingLine />
    if (data.error) return <GraphQLErrors error={data.error} />    
    const apiKey = getStripePublishableKey(data.customerBillingShop.id);
    return (
      <StripeProvider apiKey={apiKey}>
        <Elements locale={this.props.i18n.language}>
          <Form
            clientSecret={data.customerBillingSetupPaymentCredentials.clientSecret}
            shopName={data.customerBillingShop.name}          
            submitting={this.state.submitting}
            errors={this.state.errors}
            validate={validateForm}
            onSubmit={this.handleSubmit.bind(this)}
            onCancel={this.handleCancel.bind(this)}
            />
        </Elements>
      </StripeProvider>
    )
  }

}

const ADD_CREDIT_CARD = gql`
  mutation customerAddPaymentMethod($data: PaymentMethodIdInput!) {
    customerAddPaymentMethod(input: $data) {
      errors { key message }
    }
  }
`;

const QUERY = gql`
  query customerBillingShop($accountId: ID!) {
    customerBillingShop(accountId: $accountId) {
      id
      name
    }
    customerBillingSetupPaymentCredentials(accountId: $accountId) {
      clientSecret
    }
  }
`


const withQueries = compose(
  graphql(QUERY, {
    options: (props) => ({
      variables: {
        accountId: props.accountId
      },
      fetchPolicy: "network-only"
    })
  }),
  graphql(ADD_CREDIT_CARD, {
    props: ({ mutate }) => ({
      customerAddPaymentMethod: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default withTranslation("common")(connect(null, {cancelAddCreditCard})(withQueries(AddCreditCardFormContainer)));

